export default __webpack_public_path__ + "static/media/21972-312_SOC_NonCPA.ef4ccbc6.png";